module.exports = __webpack_public_path__ + "img/download-step.0b501298.webp";